import { api } from "./api";

export const getCars = () => {
    return api.get("/car");
};

export const createCar = async (body) => {
    return api.post("/car/register", body)
}

export const editCar = async (body) => {
    return api.put("/car/updt", body);
}

export const deleteCar = async (id) => {
    return api.delete(`/car/del/${id}`, )
}
  